// Search-panel schema for the IM Item Management "Location Master" tab (Delphi frmIMM0051). Field names match
// the LocationDto load params the api/im/Location/GetLocations endpoint expects (see GetLocationMasterMainStore).
// First 8 fields are visible (4 groups of 2); the rest ride along hidden via the form's field chooser.
const f = (name, label, type, visible, options) => ({
  name, tableName: "", label, type, options: options || null, apiUrl: null, grid: null, required: false, visible,
});

const LocationMasterFormLayout = [
  {
    groupId: 1,
    label: "",
    fields: [
      f("IdentityId", "Warehouse", "text", true),
      f("LocationCode", "Location", "text", true),
    ],
  },
  {
    groupId: 2,
    label: "",
    fields: [
      f("Description", "Description", "text", true),
      f("Status", "Status", "select", true),
    ],
  },
  {
    groupId: 3,
    label: "",
    fields: [
      f("ClassCode", "Class", "text", true),
      f("SubClassCode", "Sub Class", "text", true),
    ],
  },
  {
    groupId: 4,
    label: "",
    fields: [
      f("LocationType", "Location Type", "select", true),
      f("Priority", "Priority", "text", true),
    ],
  },
];

export default LocationMasterFormLayout;
